export const signUpDataChangeValidation = (
  fieldName = "",
  value = "",
  formdate = {},
  errors = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  }
) => {
  if (fieldName === "firstName") {
    if (value?.length === 0) {
      errors.firstName = "First name is required.";
    } else {
      errors.firstName = "";
    }
  }
  if (fieldName === "lastName") {
    if (value?.length === 0) {
      errors.lastName = "Last name is required.";
    } else {
      errors.lastName = "";
    }
  }
  if (fieldName === "phone") {
    if (value?.length === 0) {
      errors.phone = "Phone number is required.";
    } else {
      errors.phone = "";
    }
  }
  if (fieldName === "email") {
    const validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (value?.length === 0) {
      errors.email = "Email is required.";
    } else if (!value.match(validRegex)) {
      errors.email = "Please enter a valid email.";
    } else {
      errors.email = "";
    }
  }
  if (fieldName === "password") {
    if (value?.length === 0) {
      errors.passError = "Password is required.";
    } else if (value.length < 8) {
      errors.passError = "Password length must be of 8 characters.";
    } else {
      errors.passError = "";
    }
  }
  if (fieldName === "confirmPassword") {
    if (value?.length === 0) {
      errors.confirmPassword = "Confirm password is required.";
    } else if (value !== formdate?.password) {
      errors.confirmPassword = "Confirm password does not match.";
    } else {
      errors.confirmPassword = "";
    }
  }
  return errors;
};

export const signUpDataValidation = (
  formdate = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  }
) => {
  let isError = false;
  const errors = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  };
  if (formdate.firstName?.length === 0) {
    errors.firstName = "First name is required.";
    isError = true;
  }
  if (formdate?.lastName?.length === 0) {
    errors.lastName = "Last name is required.";
    isError = true;
  }
  if (formdate?.phone?.length === 0) {
    errors.phone = "Phone number is required.";
    isError = true;
  }
  const validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  if (formdate?.email?.length === 0) {
    errors.email = "Email is required.";
    isError = true;
  } else if (!formdate?.email.match(validRegex)) {
    errors.email = "Please enter a valid email.";
    isError = true;
  }
  if (formdate?.password?.length === 0) {
    errors.passError = "Password is required.";
    isError = true;
  } else if (formdate?.password.length < 8) {
    errors.passError = "Password length must be of 8 characters.";
    isError = true;
  }

  if (formdate?.confirmPassword?.length === 0) {
    errors.confirmPassword = "Confirm password is required.";
    isError = true;
  } else if (formdate?.confirmPassword !== formdate?.password) {
    errors.confirmPassword = "Confirm password does not match.";
    isError = true;
  }
  return { errors, isError };
};

export const validateEmail = (email) => {
  // Regular expression for validating an Email
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const extractModulesInMentionedOrder = (
  sidebarItems = [],
  modulesList = []
) => {
  const generatedList = [...sidebarItems.slice(0, 2)];
  modulesList.forEach((module) => {
    const filterdItem = sidebarItems.find((item) => item?.value === module);
    if (filterdItem) {
      generatedList.push(filterdItem);
    }
  });
  sidebarItems.forEach((module) => {
    const filterdItem = generatedList.find(
      (item) => item?.value === module?.value
    );
    if (!filterdItem) {
      generatedList.push(module);
    }
  });

  return generatedList;
};
